import * as React from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import styled from "styled-components"
import parse from "html-react-parser"
import { useStaticQuery, graphql } from "gatsby"

import Layout from "../components/layout"
import Seo from "../components/seo"
import OutlineButton from "../components/buttons/outlineButton";
import TopDocForm from "../components/forms/top-doc"

const HeroSection = styled.section`
  background-color: #6C7E99;
  position: relative;
  margin-top: -66px;
  padding-top: 66px;
  background-color: #6C7E99;
  background-image: url("../images/reset/reset-hero-bg.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;

  @media (max-width: 756px) {
    margin-top: 0;
    padding-top: 3rem;
  }

  > * {
    position: relative;
    z-index: 1;
  }
`

const HeroInner = styled.div`
  max-width: calc(1160px - 2rem);
  margin: 0 auto;
  padding: 1rem 1rem;
  display: flex;
  gap: 2rem;
  justify-content: center;
  align-items: center;
  z-index: 2;

  @media (max-width: 756px) {
    flex-direction: column;
  }
`;

const HeroHeading = styled.h1`
  color: #FFFFFF;
  font-size: clamp(2.625rem, 1.7679rem + 4.2857vw, 4.875rem);
  font-weight: 700;
  line-height: 1.1;
  margin-bottom: 1rem;
  padding-top: 1rem;
  text-align: center;
`

const HeroCTA = styled(OutlineButton)`
  border-color: #24293C;
  background-color: #24293C;
  border-radius: 0;
  color: #DAE0EE;
  margin-bottom: 3rem !important;
  display: inline-block;
  font-size: 18px;
  font-weight: 500;
  padding: 0.5em 2em;
  text-transform: none;

  &:hover, &:focus {
    background-color: #DAE0EE;
    color: #222A3F;
  }
`

const MediaBlock = styled.div`
  background-color: #fff;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

const QuoteSection = styled.section`
  background-color: #F5F7FA;
  padding: 10rem 0 0;
  margin-top: -9rem;
  position: relative;
  z-index: 1;
`

const QuoteSectionInner = styled.div`
  max-width: calc(800px - 2rem);
  margin: 0 auto;
  padding: 3rem 1rem 1rem;

  @media (max-width: 756px) {
    padding: 0 0 0.5rem;
  }
`

const Quote = styled.blockquote`
  background-color: #fff;
  border-radius: 0.5rem;
  padding: 2rem 2rem 0;
  position: relative;
  z-index: 1;
  font-size: clamp(1.25rem, 1.1071rem + 0.7143vw, 1.625rem);
    line-height: 1.5;
    position: relative;

    span {
      position: relative;
      z-index: 1;
    }

    &:before {
      display: block;
      content: "";
      position: absolute;
      background-image: url("../images/icons/quote.svg");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 5.3em;
      overflow: visible;
      left: -2.5em;
      top: -3.7em;
      width: 7em;
      height: 7em;
      z-index: 0;
      opacity: 0.3;

      @media (max-width: 756px) {
        background-size: 75px;
        width: 75px;
        height: 75px;
        left: -8px;
        top: -16px;
      }
    }
`

const YouTubeWrapper = styled.div`
  position: relative;
  min-width: 287px;
  max-width: 100%;

  &:before {
    content: '';
    display: block;
    padding-top: calc(16 / 9 * 100%);
  }

  > * {
    height: 100%;
    width: 100%;
    margin-bottom: 0 !important;
    position: absolute;
    top: 0;
    left: 0;
  }

  .gatsby-image-wrapper {
    aspect-ratio: 16 / 9;
  }

  button {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    webkit-appearance: none;
    background-color: rgba(0, 0, 0, 0.5);
    border: none;
    z-index: 2;
    opacity: 0;
    cursor: pointer;
    transition: opacity 0.2s ease-in-out;


    &:hover, &:focus {
      opacity: 1;
    }

    @media (max-width: 756px) {
      opacity: 1;
      background-color: rgba(0, 0, 0, 0.25);
    }

    span {
      background-image: url("../images/icons/play.svg");
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
      z-index: 3;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: inline-block;
      height: 3rem;
      width: 3rem;
    }
  }
`;

const FormSection = styled.section`
  background-color: #F5F7FA;
  padding: 3rem 0;

  @media (max-width: 768px) {
    padding: 0;
  }
`

const FormSectionInner = styled.div`
  max-width: calc(1160px - 2rem);
  margin: 0 auto;
  padding: 1rem 1rem;
  display: flex;
  gap: 2rem;

  @media (max-width: 1000px) {
    flex-direction: column;
  }
`

const Instructions = styled.div`
    flex: 1;
    padding: 40px;
    font-size: clamp(1.1rem, 0.8857rem + 0.9524vw, 1.6rem);

    h2 {
        font-size: 1.2em;
    }

    ol li {
        font-size: 1em;
    }

    .has-medium-font-size {
        font-size: 1.1em !important;
    }

    @media (max-width: 1000px) {
        flex: 1 1 100%;
        min-width: 100%;
        max-width: 100%;
        padding-left: 0;
        padding-right: 0;
    }

    @media (max-width: 768px) {
      padding-top: 0;
      padding-bottom: 0;
    }
`


const TopDoc = data => {
  const page = data.data.page;

  const playVideo = (e) => {
    e.preventDefault();
    const parent = e.target.closest('[data-url]');
    const dataUrl = parent.getAttribute('data-url');
    const iframe = document.createElement('iframe');
    iframe.setAttribute('allowfullscreen', 'true');
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allow', 'autoplay');

    if ( dataUrl.match(/youtube\.com/) ) {
      let youtubeID;

      if ( dataUrl.match(/(\?|&)v=/) ) {
        youtubeID = dataUrl.split('v=')[1];
      } else if ( dataUrl.match(/(\.be\/)+/) ) {
        youtubeID = dataUrl.split('.be/')[1];
      } else if ( dataUrl.match(/(shorts\/)+/) ) {
        youtubeID = dataUrl.split('shorts/')[1];
      }

      const queryPosition = youtubeID.indexOf('?');
      const ampersandPosition = youtubeID.indexOf('&');
      
      if (queryPosition !== -1) {
        youtubeID = youtubeID.substring(0, queryPosition);
      }

      if (ampersandPosition !== -1) {
        youtubeID = youtubeID.substring(0, ampersandPosition);
      }

      const url = `https://www.youtube.com/embed/${youtubeID}?autoplay=1&loop=1`;
      
      iframe.setAttribute('src', url);
      parent.innerHTML = iframe.outerHTML;
      iframe.addEventListener('load', () => {
        iframe.play();
      });
    } else if ( dataUrl.match(/vimeo\.com/) ) {
      let vimeoID = dataUrl.split('vimeo.com/')[1];

      const queryPosition = vimeoID.indexOf('?');
      const ampersandPosition = vimeoID.indexOf('&');
      
      if (queryPosition !== -1) {
        vimeoID = vimeoID.substring(0, queryPosition);
      }

      if (ampersandPosition !== -1) {
        vimeoID = vimeoID.substring(0, ampersandPosition);
      }

      const url = `https://player.vimeo.com/video/${vimeoID}?autoplay=1&loop=1`;
      iframe.setAttribute('src', url);
      parent.innerHTML = iframe.outerHTML;
      iframe.addEventListener('load', () => {
        iframe.play();
      });
    }
  }

  const meta = useStaticQuery(graphql`
  query TopDocQuery {
    page: wpPage(databaseId: {eq: 9914}) {
      topDoc {
        topDocHero {
          title
          video {
            url
            poster {
              node {
                altText
                localFile {
                  childImageSharp {
                    gatsbyImageData(width: 600, placeholder: BLURRED, formats: [AUTO, WEBP, AVIF])
                  }
                }
              }
            }
          }
          images {
            before {
              node {
                altText
                localFile {
                  childImageSharp {
                    gatsbyImageData(width: 600, placeholder: BLURRED, formats: [AUTO, WEBP, AVIF])
                  }
                }
              }
            }
            after {
              node {
                altText
                localFile {
                  childImageSharp {
                    gatsbyImageData(width: 600, placeholder: BLURRED, formats: [AUTO, WEBP, AVIF])
                  }
                }
              }
            }
          }
          quote {
            text
            button {
              label
              url
            }
          }
        }
        topDocInstructions {
          heading
          content
        }
        topDocForm {
          howDidYouHeaderAboutUsOptions {
            label
          }
          appointmentRegardingOptions {
            label
          }
          webHook
        }
      }
    }
  }
  `)

  const topDoc = meta.page.topDoc;
  const hero = topDoc.topDocHero;
  const heroVideo = hero.video;
  const instructions = topDoc.topDocInstructions;
  const form = topDoc.topDocForm;

  return (
    <Layout>
      <Seo title={page.seo.title} description={page.seo.metaDesc} seo={page.seo} />
      <style
        dangerouslySetInnerHTML={
          {
            __html: `
              .page-header:not(.sticky){
                box-shadow: none;
              }
              .page-header:not(.sticky),
              .page-header:not(.sticky) #header-menu-toggle {
                background-color: transparent;
                color: #fff;
              }

              .page-header:not(.sticky) #header-menu-toggle > span > span { 
                background-color: #fff;
              }

              @media (min-width: 1204px) {
                .page-header:not(.sticky) *:not(#header-menu-explore, #header-menu-explore-toggle, #search-toggle) {
                  background-color: transparent;
                  color: #fff;
                }
                .page-header:not(.sticky) #header-menu-explore-toggle,
                .page-header:not(.sticky) #header-menu-explore-toggle span,
                .page-header:not(.sticky) #search-toggle {
                  filter: invert(1);
                }
              }

              .page-header[class]:not(.sticky) .main-logo__text[class][class]:not(.sticky) {
                fill: #fff !important;
              }

              .page-header:not(.sticky) #header-menu-explore li a {
                color: rgb(34, 42, 63);
              }

              .page-header:not(.sticky) #search-toggle {
                filter: invert(1);
              }
            `
          }
        }
      />
      <HeroSection>
      <HeroHeading>{parse(hero.title || '')}</HeroHeading>
        <HeroInner>
          <YouTubeWrapper data-url={heroVideo.url}>
            {heroVideo.poster && <GatsbyImage image={heroVideo.poster.node.localFile.childImageSharp.gatsbyImageData} alt={heroVideo.poster.node.altText || ''} /> }
            <button aria-label="Play" onClick={playVideo}><span></span></button>
          </YouTubeWrapper>
          <MediaBlock>
            <GatsbyImage image={hero.images.before.node.localFile.childImageSharp.gatsbyImageData} alt={hero.images.before.node.altText || ''} />
            <GatsbyImage image={hero.images.after.node.localFile.childImageSharp.gatsbyImageData} alt={hero.images.after.node.altText || ''} />
          </MediaBlock>
        </HeroInner>
      </HeroSection>
      <QuoteSection>
        <QuoteSectionInner>
          <Quote>
            {parse(hero.quote.text || '')}
            {hero.quote.button && hero.quote.button.url && <HeroCTA to={hero.quote.button.url}>{hero.quote.button.label}</HeroCTA>}
          </Quote>
        </QuoteSectionInner>
      </QuoteSection>
      <FormSection>
        <FormSectionInner>
          <Instructions className="blog-post">
            {instructions.heading && <h2>{parse(instructions.heading || '')}</h2>}
            {parse(instructions.content || '')}
          </Instructions>
          <TopDocForm howDidYouHearAboutUsOptions={form.howDidYouHeaderAboutUsOptions} appointmentRegardingOptions={form.appointmentRegardingOptions} webHook={form.webHook} />
        </FormSectionInner>
      </FormSection>
    </Layout>
  )
}

export default TopDoc